//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/NXObject.js";
let d=[[[0,"ActionType",1,0],[0,"CategoryName",1,0],[0,"HasCsysImport",1,0],[0,"HasSketchImport",1,0],[0,"KrxFile",1,0],[0,"LibName",1,0],[0,"NativeItem",1,0],[0,"ObjectId",1,0],[0,"PartFile",1,0],[0,"PartType",1,0],[0,"PathInLib",1,0],[0,"SpareDialogForDragAndDrop",1,0],[0,"TemplateName",1,0],[0,"TypeName",1,0]],[],[]];
SPLM.LineDesigner.ReuseLibraryDragData = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.ReuseLibraryDragData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;